export default function FilterCheckboxes({
  selectAllChildren,
  selectFirstChild,
}) {
  return (
    <div className="hitq-checkbox-container">
      <label>
        <input
          type="checkbox"
          name="all-children"
          checked={selectAllChildren.value}
          onChange={selectAllChildren.toggleAllChildrenFilter}
        />
        Select all children
      </label>
      <label>
        <input
          type="checkbox"
          name="first-child"
          checked={selectFirstChild.value}
          onChange={selectFirstChild.toggleFirstChildFilter}
        />
        Select children of level 1 only
      </label>
    </div>
  );
}
